var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionMarkInfoBlue = function SvgQuestionMarkInfoBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 27 26"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13,
    r: 11.5,
    fill: "transparent",
    stroke: "#3AACC8",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3AACC8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.995,
    d: "M10.604 7.4c1.558-1.363 4.085-1.363 5.643 0s1.558 3.574 0 4.937a4 4 0 0 1-.892.588c-.992.48-1.93 1.328-1.93 2.43v.997m0 3.99h.01v.01h-.01z"
  })));
};
export { SvgQuestionMarkInfoBlue as ReactComponent };
export default __webpack_public_path__ + "6679184464667502db3d1dff331e72e7.svg";